/**
 * Copy for the page templates (src/templates). Copying a template: copy this namespace too,
 * rename it after the new page and replace the copy.
 */
export const templatesPtBr = {
  form: {
    title: 'Novo registro',
    submit: 'Criar registro',
    breadcrumb: 'Registros',
    cancel: 'Cancelar',
    saveDraft: 'Salvar rascunho',
    tabs: { general: 'Dados gerais', values: 'Valores' },
    sections: { values: 'Valores', limits: 'Limites' },
    fields: {
      name: 'Nome',
      code: 'Código',
      codeHint: 'Gerado se ficar vazio',
      description: 'Descrição',
      amount: 'Valor',
      currency: 'Moeda',
      start: 'Início',
      end: 'Fim',
    },
    errors: { nameRequired: 'Nome é obrigatório', amountRequired: 'Valor é obrigatório' },
    aside: { title: 'Resumo', amount: 'Valor', period: 'Período' },
  },
  columns: {
    name: 'Nome',
    owner: 'Responsável',
    status: 'Status',
    updatedAt: 'Atualizado em',
    amount: 'Valor',
  },
  filters: { withAmount: 'Apenas com valor' },
  status: { active: 'Ativo', pending: 'Pendente', archived: 'Arquivado' },
  listing: {
    nounOne: 'registro',
    nounOther: 'registros',
    views: 'Visões',
    viewAll: 'Todos',
    title: 'Registros',
    subtitle: 'Tudo o que a equipe acompanha neste módulo',
    create: 'Novo registro',
    export: 'Exportar',
    archive: 'Arquivar',
    searchLabel: 'Buscar registro',
    searchPlaceholder: 'Buscar por nome ou código',
    openRow: 'Abrir {{name}}',
    emptyTitle: 'Nenhum registro ainda',
    emptyDescription: 'Crie o primeiro registro para começar a acompanhar.',
  },
  detail: {
    fallbackTitle: 'Registro',
    breadcrumb: 'Registros',
    edit: 'Editar',
    archive: 'Arquivar',
    tabs: { overview: 'Visão geral', items: 'Itens', history: 'Histórico' },
    sections: { general: 'Dados gerais', values: 'Valores' },
    fields: {
      code: 'Código',
      owner: 'Responsável',
      status: 'Status',
      updatedAt: 'Atualizado em',
      amount: 'Valor',
    },
    itemsLabel: 'Itens do registro',
    historyEmptyTitle: 'Nenhuma alteração registrada',
    historyEmptyDescription: 'As mudanças neste registro aparecem aqui.',
    loadError: 'Não foi possível carregar o registro',
  },
};

export const templatesEn: typeof templatesPtBr = {
  form: {
    title: 'New record',
    submit: 'Create record',
    breadcrumb: 'Records',
    cancel: 'Cancel',
    saveDraft: 'Save draft',
    tabs: { general: 'General', values: 'Amounts' },
    sections: { values: 'Amounts', limits: 'Limits' },
    fields: {
      name: 'Name',
      code: 'Code',
      codeHint: 'Generated when left empty',
      description: 'Description',
      amount: 'Amount',
      currency: 'Currency',
      start: 'Start',
      end: 'End',
    },
    errors: { nameRequired: 'Name is required', amountRequired: 'Amount is required' },
    aside: { title: 'Summary', amount: 'Amount', period: 'Period' },
  },
  columns: {
    name: 'Name',
    owner: 'Owner',
    status: 'Status',
    updatedAt: 'Updated on',
    amount: 'Amount',
  },
  filters: { withAmount: 'With an amount only' },
  status: { active: 'Active', pending: 'Pending', archived: 'Archived' },
  listing: {
    nounOne: 'record',
    nounOther: 'records',
    views: 'Views',
    viewAll: 'All',
    title: 'Records',
    subtitle: 'Everything the team tracks in this module',
    create: 'New record',
    export: 'Export',
    archive: 'Archive',
    searchLabel: 'Search records',
    searchPlaceholder: 'Search by name or code',
    openRow: 'Open {{name}}',
    emptyTitle: 'No records yet',
    emptyDescription: 'Create the first record to start tracking.',
  },
  detail: {
    fallbackTitle: 'Record',
    breadcrumb: 'Records',
    edit: 'Edit',
    archive: 'Archive',
    tabs: { overview: 'Overview', items: 'Items', history: 'History' },
    sections: { general: 'General', values: 'Amounts' },
    fields: {
      code: 'Code',
      owner: 'Owner',
      status: 'Status',
      updatedAt: 'Updated on',
      amount: 'Amount',
    },
    itemsLabel: 'Record items',
    historyEmptyTitle: 'No changes recorded',
    historyEmptyDescription: 'Changes to this record show up here.',
    loadError: 'Could not load the record',
  },
};
